import { actionTypes } from '../types';
import { returnReadableTime, getFigcaptionTitle } from '../tools/helpers';
import { i18n } from '@/tools/i18n';

export default {
	init() {
		[...this.$el.querySelectorAll('.post--video')].forEach(post => {
			post.addEventListener('click', () => {
				const $mediaId = post.querySelector('[media-id]');
				const mediaID = $mediaId ? $mediaId.getAttribute('media-id') : null;
				const isSynced = post.hasAttribute('synced');
				this.$store.dispatch(actionTypes.videoLoadAndPlay, { mediaID, isSynced });
			});
			if (post.querySelector('time')) {
				const time = post.querySelector('time').textContent;
				if (time) post.querySelector('time').textContent = returnReadableTime(parseFloat(time));
			}
			const $icon = post.querySelector('.element__icon');
			if ($icon) {
				$icon.setAttribute('role', 'button');
				$icon.setAttribute('tabindex', 0);
				$icon.setAttribute('aria-label', `${i18n.t('playVideo')} ${getFigcaptionTitle(post)}`);
			}

			const $description = post.querySelector('.element__caption__text');
			if ($description) {
				$description.setAttribute('role', 'text');
				$description.setAttribute('tabindex', 0);
				$description.setAttribute('aria-label', `${i18n.t('videoDescription')} ${$description.textContent}`);
			}
			[...post.querySelectorAll('.element__caption__headline, .element__caption__time')].forEach(element =>
				element.setAttribute('aria-hidden', true)
			);
		});
	},
};
